const ReferralStatuses = {
  in_network: {
    statuses: [
      { id: 'sent', name: 'Sent' },
      { id: 'reminder', name: 'Reminder' },
      { id: 'acknowledged', name: 'Acknowledged' },
      { id: 'assigned', name: 'Assigned' },
      { id: 'in_progress', name: 'In progress' },
      { id: 'reassigned', name: 'Reassigned' },
      { id: 'unsuccessful', name: 'Not eligible' },
      { id: 'rejected', name: 'Not utilized' },
      { id: 'utilized', name: 'Utilized' }
    ],
    referral_update_status_options: [
      { value: 'utilized', label: 'Utilized' },
      { value: 'in_progress', label: 'In progress' },
      { value: 'unsuccessful', label: 'Not eligible' },
      { value: 'rejected', label: 'Not utilized' }
    ]
  },
  in_network_non_clr: {
    referral_update_status_options: [
      { value: 'utilized', label: 'Utilized' },
      { value: 'in_progress', label: 'In progress' },
      { value: 'unsuccessful', label: 'Unsuccessful' },
      { value: 'rejected', label: 'Rejected' }
    ]
  },
  out_of_network: {
    statuses: [
      { id: 'planned', name: 'Referred' },
      { id: 'accessed', name: 'Accessed' },
      { id: 'unsuccessful', name: 'Unsuccessful' },
      { id: 'rejected', name: 'Rejected' },
      { id: 'utilized', name: 'Utilized' }
    ],
    referral_update_status_options: [
      { value: 'utilized', label: 'Yes' },
      { value: 'planned', label: 'Not yet' },
      { value: 'unsuccessful', label: 'No, client did not meet requirements' },
      { value: 'rejected', label: 'No, client rejected it' }
    ]
  },
  labels: {
    planned: {
      is_clr: 'Referred',
      is_not_clr: 'In Progress'
    },
    unsuccessful: {
      is_clr: {
        is_access_event_clr: 'Not eligible',
        is_access_event_not_clr: 'Unsuccessful'
      },
      is_not_clr: 'Client ineligible'
    },
    rejected: {
      is_clr: {
        is_access_event_clr: 'Not utilized',
        is_access_event_not_clr: 'Rejected'
      },
      is_not_clr: 'Client rejected'
    }
  },
  memberLabels: {
    accessed: {
      /* Note: It doesn't appear 'accessed' status labels are used for Members */
      is_not_clr: 'I accessed this'
    },
    planned: {
      is_clr: 'Referred',
      is_not_clr: 'In Progress'
    },
    unsuccessful: {
      is_not_clr: "I'm not eligible"
    },
    rejected: {
      is_not_clr: 'I decided not to use it'
    },
    utilized: {
      is_not_clr: 'I used it!'
    }
  },
  sortByStatus: function () {
    var statusSortOrder = [
      'sent',
      'reminder',
      'acknowledged',
      'assigned',
      'reassigned',
      'planned',
      'in_progress',
      'accessed',
      'utilized',
      'rejected',
      'unsuccessful'
    ];

    return function (a, b) {
      if (a.status && b.status) {
        if (statusSortOrder.indexOf(a.status) > statusSortOrder.indexOf(b.status)) {
          return 1;
        } else if (statusSortOrder.indexOf(b.status) > statusSortOrder.indexOf(a.status)) {
          return -1;
        } else {
          return 0;
        }
      } else {
        return 0;
      }
    };
  }
};

export default ReferralStatuses;
